import React from 'react';
import { Button, Carousel, Container, Image } from 'react-bootstrap';
import HalloweenDucks from "../img/art-Image/Halloween-Ducks.jpg";
import Bruja from "../img/art-Image/Halloween-Bruja.jpg";
import Mouseketeer from "../img/art-Image/Mouseketeer.jpg";
import LeftSide from "../img/art-Image/Art-Left.png";
import RightSide from "../img/art-Image/Art-Right.png";
import BonnitasFresitas from "../img/art-Image/BonnitasFresitasLogo.png";
import JayNicholFit from "../img/art-Image/jayNicoleFitLogo.png";
import '../style/artPage.css';


function Disenoz() {
    return (
        <>


            <Carousel className="carousel-fade">
                <Carousel.Item interval={500}>
                    <img
                        className="d-block w-100"
                        src={HalloweenDucks}
                        alt="Huey Duey Louie Halloween"
                    />
                </Carousel.Item>
                <Carousel.Item interval={500}>
                    <img
                        className="d-block w-100"
                        src={Mouseketeer}
                        alt="Hidden Mouseketeer"
                    />
                </Carousel.Item>
                <Carousel.Item interval={500}>
                    <img
                        className="d-block w-100"
                        src={Bruja}
                        alt="Evil witch Snow White Shot Tequila"
                    />
                </Carousel.Item>
            </Carousel>
            <Container className="art-Sec space-Bottom"  fluid>
                <Image  className="img-Width" src={LeftSide} alt="Hidden Mouseketeer disney Mickey mouse"/>
                <Button variant="danger" size="lg" href="/Profolio">Diseñoz</Button>
                <Image  className="img-Width" src={RightSide} alt="stormtrooper starward oogieboogie oogie boogie moon"/>
            </Container>
            <Container className="art-Sec space-Bottom" fluid>
                <Image src={BonnitasFresitas} className="img-Width" />
                <Button variant="danger" size="lg" href="/Commisions" >Commissions</Button>
                <Image  src={JayNicholFit} className="img-Width" />
                <Image />
            </Container>
        </>
    );
}

export default Disenoz;